import React from "react";
import { connect } from "react-redux";

import Col from "antd/es/col";
import Row from "antd/es/row";
import { useIntl } from "react-intl";

import { LoadingSpinner } from "@mapmycustomers/ui";

import TextWithInfo from "@app/component/typography/TextWithInfo";
import { getEmailQuota, isEmailQuotaLoading } from "@app/store/email";
import { RootState } from "@app/store/rootReducer";

import EmailQuotaInfo from "../../EmailQuotaInfo";

import styles from "./EmailSummaryInfo.module.scss";

interface EmailSummaryInfoProps {
  footer?: React.ReactNode;
}

const EmailSummaryInfo = ({
  emailQuota,
  emailQuotaLoading,
  footer,
}: EmailSummaryInfoProps & ReturnType<typeof mapStateToProps>) => {
  const intl = useIntl();

  return (
    <div className={styles.container}>
      {!emailQuota || emailQuotaLoading ? (
        <LoadingSpinner />
      ) : (
        <>
          <Row align="middle" justify="space-between">
            <Col className={styles.infoText}>
              <TextWithInfo
                info={intl.formatMessage({
                  id: "component.email.summaryInfo.point.tooltip",
                  defaultMessage:
                    "Activities will be logged when each email is sent. You can edit individual activities after they're created.",
                  description: "Second point tooltip in the email summary info.",
                })}
                placement="top"
              >
                {intl.formatMessage({
                  id: "component.email.summaryInfo.point",
                  defaultMessage: "Pending sends",
                  description: "Second point in the email summary info.",
                })}
              </TextWithInfo>
            </Col>
            <Col className={styles.infoValue}>
              {emailQuota ? emailQuota.submitted + emailQuota.processing : 0}
            </Col>
          </Row>
          <EmailQuotaInfo />
        </>
      )}
      {footer}
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  emailQuota: getEmailQuota(state),
  emailQuotaLoading: isEmailQuotaLoading(state),
});

export default connect(mapStateToProps)(EmailSummaryInfo);
